"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSimpleContentCard = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.StyledSimpleContentCard = styled_components_1.default.div(function (_a) {
    var _b = _a.theme, borderWidths = _b.borderWidths, colors = _b.colors, radii = _b.radii, space = _b.space, mediaQueries = _b.mediaQueries;
    return "\n    background: ".concat(colors.canvas, ";\n    border: ").concat(borderWidths.standard, " solid ").concat(colors.borderMuted, ";\n    border-radius: ").concat(radii.standard, ";\n    padding: ").concat(space[3], ";\n\n    ").concat(mediaQueries.smallAndUp, " {\n        padding: ").concat(space[4], ";\n    }\n  ");
});
